module.exports = {"654223100":"三道河子镇","654223101":"四道河子镇","654223102":"老沙湾镇","654223103":"乌兰乌苏镇","654223104":"安集海镇","654223105":"东湾镇","654223106":"西戈壁镇","654223107":"柳毛湾镇","654223108":"金沟河镇","654223200":"商户地乡","654223201":"大泉乡","654223202":"博尔通古乡","654223400":"牛圈子牧场","654223401":"博尔通古牧场","654223402":"良种场","654223503":"兵团一二一团","654223506":"兵团一三三团","654223507":"兵团一三四团","654223509":"兵团一四一团","654223510":"兵团一四二团","654223511":"兵团一四三团","654223512":"兵团一四四团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654223.json
// module id = 3139
// module chunks = 0